export const MYSTUDENT_ROUTES = {
  TRACKING: 'tracking',
  LESSONS: 'lessons',
  SETTINGS: 'settings',
  REVIEW_AND_FEEDBACK: 'review-and-feedback',
};
